export const SET_LOADING = 'SET_LOADING'
export const SET_USER_ACTIVE = 'SET_USER_ACTIVE'
export const SET_USER_INACTIVE = 'SET_USER_INACTIVE'
export const SET_USER_WITH_PERMISSIONS = 'SET_USER_WITH_PERMISSIONS'

export const url = {
    active: '/apiuseradmin/?active=yes',
    inactive: '/apiuseradmin/?active=no'
}